import listingActionTypes from 'circe/listing/actionTypes';
import { NAME } from './constants';

export default {
  ...listingActionTypes(NAME),
  REVOKE: `${NAME}/REVOKE`,
  REVOKED: `${NAME}/REVOKED`,
  REVOKE_FAILED: `${NAME}/REVOKE_FAILED`,
  REPLENISH: `${NAME}/REPLENISH`,
  REPLENISHED: `${NAME}/REPLENISHED`,
  REPLENISH_FAILED: `${NAME}/REPLENISH_FAILED`,
  CREATE: `${NAME}/CREATE`,
  CREATED: `${NAME}/CREATED`,
  CREATE_FAILED: `${NAME}/CREATE_FAILED`,
  INVOICE_CREATE: `${NAME}/INVOICE_CREATE`,
  INVOICE_CREATED: `${NAME}/INVOICE_CREATED`,
  INVOICE_CREATE_FAILED: `${NAME}/INVOICE_CREATE_FAILED`,
  ACTIVATE: `${NAME}/ACTIVATE`,
  ACTIVATED: `${NAME}/ACTIVATED`,
  ACTIVATE_FAILED: `${NAME}/ACTIVATE_FAILED`,
};
